import React from 'react';

function Calendar() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      fill="none"
      viewBox="0 0 14 14"
    >
      <path
        fill="#3AB2EE"
        stroke="#3AB2EE"
        d="M9.833 1.667v.5h1.834a1.5 1.5 0 011.06.439l.354-.354-.354.354a1.5 1.5 0 01.44 1.06v8a1.5 1.5 0 01-1.5 1.5H2.333a1.5 1.5 0 01-1.06-.439l-.354.354.354-.354a1.5 1.5 0 01-.44-1.06v-8a1.5 1.5 0 011.5-1.5h1.834V1A.167.167 0 114.5 1v1.167h5V1a.167.167 0 01.333 0v.667zM1.667 6.5h-.5v5.167a1.167 1.167 0 001.166 1.166h9.334c.309 0 .606-.123.825-.341l-.354-.354.354.354c.218-.22.341-.516.341-.825V6.5H1.667zm10.666-.333h.5v-2.5A1.167 1.167 0 0011.667 2.5H9.833v1.167a.167.167 0 11-.333 0V2.5h-5v1.167a.167.167 0 11-.333 0V2.5H2.333a1.167 1.167 0 00-1.166 1.167v2.5h11.166z"
      ></path>
    </svg>
  );
}

export default Calendar;
